
import { useTranslation } from 'react-i18next';

export default function TeamSection() {

  const { t } = useTranslation();

  const advantages = [
    {
      icon: 'ri-team-line',
      title: t('about.proTeam'),
      description: t('about.proTeam.desc'),
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20team%20meeting%20in%20modern%20office%2C%20diverse%20group%20of%20financial%20experts%20discussing%20trading%20strategies%2C%20clean%20corporate%20environment%20with%20golden%20lighting&width=400&height=300&seq=professional-team&orientation=landscape'
    },
    {
      icon: 'ri-customer-service-2-line',      
      title: t('about.proService'),
      description: t('about.proService.desc'),
      image: 'https://readdy.ai/api/search-image?query=Professional%20customer%20service%20representative%20with%20headset%20in%20modern%20office%2C%20friendly%20business%20woman%20providing%20client%20support%2C%20clean%20corporate%20background&width=400&height=300&seq=professional-service&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',     
      title: t('about.sec'),
      description: t('about.sec.desc'),
      image: 'https://readdy.ai/api/search-image?query=Secure%20financial%20trading%20platform%20interface%20on%20computer%20screen%2C%20cybersecurity%20shield%20icons%2C%20professional%20trading%20environment%20with%20security%20elements&width=400&height=300&seq=security-first&orientation=landscape'
    },
    {
      icon: 'ri-bank-line',      
      title: t('about.strict'),
      description: t('about.strict.desc'),
      image: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20financial%20district%20skyline%20with%20modern%20banking%20buildings%2C%20regulatory%20compliance%20concept%2C%20professional%20financial%20supervision%20environment&width=400&height=300&seq=strict-supervision&orientation=landscape'
    },
    {
      icon: 'ri-time-line',      
      title: t('about.fastDes'),
      description: t('about.fastDes.desc'),
      image: 'https://readdy.ai/api/search-image?query=Fast%20digital%20payment%20processing%20on%20mobile%20device%2C%20instant%20money%20transfer%20interface%2C%20modern%20fintech%20banking%20application%20with%20speed%20elements&width=400&height=300&seq=fast-deposit&orientation=landscape'
    },
    {
      icon: 'ri-apps-2-line',      
      title: t('about.productSafe'),
      description: t('about.productSafe.desc'),
      image: 'https://readdy.ai/api/search-image?query=Various%20precious%20metal%20products%20gold%20silver%20platinum%20bars%20and%20coins%20displayed%20professionally%2C%20luxury%20investment%20products%20showcase%2C%20clean%20elegant%20presentation&width=400&height=300&seq=product-safety&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-amber-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('about.whyGLB')}</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">{t('about.whyGLB.desc')}</p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {advantages.map((advantage, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative">
                <img 
                  src={advantage.image}
                  alt={advantage.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                <div className="absolute top-4 left-4 w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center">
                  <i className={`${advantage.icon} text-white text-xl`}></i>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{advantage.title}</h3>
                <p className="text-gray-600 leading-relaxed">{advantage.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-16">
          <div className="bg-white rounded-xl p-8 shadow-lg max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">{t('about.readyToStart')}</h3>
            <p className="text-gray-600 mb-6">{t('about.join')}</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-gradient-to-r from-amber-500 to-yellow-500 text-white px-8 py-3 rounded-lg font-semibold hover:from-amber-600 hover:to-yellow-600 transition-all duration-300 whitespace-nowrap">
                {t('about.openTradingAcc')}
              </button>
              <button className="border-2 border-amber-500 text-amber-600 px-8 py-3 rounded-lg font-semibold hover:bg-amber-50 transition-all duration-300 whitespace-nowrap">
                {t('about.contactTeam')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
